// extracted by mini-css-extract-plugin
export default {"list_container":"DNDLayout_list_container"};